import { render, staticRenderFns } from "./configGuessProvince.vue?vue&type=template&id=617d6c2f&"
import script from "./configGuessProvince.vue?vue&type=script&lang=js&"
export * from "./configGuessProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports